import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-resource-card-grid-skeleton',
  templateUrl: './resource-card-grid-skeleton.component.html',
  styleUrls: ['./resource-card-grid-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class ResourceCardGridSkeletonComponent {
  @Input() colClass = 'col-6 col-lg-4 skeleton-grid-container';
  @Input() cardCount = 6;
  readonly cardIndices = new Array(this.cardCount);
}
